import { render, staticRenderFns } from "./GiftCatalog.vue?vue&type=template&id=551ece04&scoped=true"
import script from "./GiftCatalog.vue?vue&type=script&lang=js"
export * from "./GiftCatalog.vue?vue&type=script&lang=js"
import style0 from "./GiftCatalog.vue?vue&type=style&index=0&id=551ece04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551ece04",
  null
  
)

export default component.exports